import { render } from "./ErrTip.vue?vue&type=template&id=b035be7e&scoped=true"
import script from "./ErrTip.vue?vue&type=script&lang=js"
export * from "./ErrTip.vue?vue&type=script&lang=js"

import "./ErrTip.vue?vue&type=style&index=0&id=b035be7e&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-b035be7e"

export default script